import { PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';
import {
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import {
	StyledContainer,
	StyledModalTitle,
	StyledModalWrapper,
} from './BankModal.styled';

interface IBankModalProps {
	open: boolean;
	title: string;
	onClose: () => void;
}

const BankModal: React.FC<PropsWithChildren<IBankModalProps>> = ({
	open,
	title,
	onClose,
	children,
}) => {
	return (
		<CSSTransition
			in={open}
			timeout={300}
			classNames={'bank-modal'}
			unmountOnExit
		>
			<StyledModalWrapper>
				<StyledContainer>
					<StyledModalTitle>
						<Text>{title}</Text>
						<CloseButton
							onClick={onClose}
							height={ButtonHeight.Height20}
							color={ButtonColors.Default}
							borderRadius={ButtonBorderRadius.Radius5}
							iconSize={10}
						/>
					</StyledModalTitle>
					<Divider $direction={'H'} style={{ opacity: 0.1 }} />
					{children}
				</StyledContainer>
			</StyledModalWrapper>
		</CSSTransition>
	);
};

export { BankModal };
